// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__hAdNh","title":"Skills_title__VxwC3"};